# GraphQL fragment to get basic info about a step template
# within the sales automation environment.

fragment SalesAutomationAssignable on Assignable {
    id
    name
    type
    ... on User {
        avatarUrl
        initials
    }
}
